import { createContext, useContext } from "react";
import { INITIAL_CART_CONTEXT_STATE } from "./utils/constants";
import { useCartCards } from "./utils/useCartCards";
import { useCartShow } from "./utils/useCartShow";

const CartContext = createContext(INITIAL_CART_CONTEXT_STATE);

const CartProvider = ({ children }) => {
  const { cartIsOpen, toggleCartOpening } = useCartShow();
  const {
    addMultipleCards,
    cart,
    removeCard,
    setAffiliateUrl,
    getInitialCards,
    emptyCart,
    clearErrorMessage
  } = useCartCards();

  return (
    <CartContext.Provider
      value={{
        cart,
        cartIsOpen,
        toggleCartOpening,
        addMultipleCards,
        removeCard,
        setAffiliateUrl,
        getInitialCards,
        emptyCart,
        clearErrorMessage
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

const useCartContext = () => useContext(CartContext);

export { CartProvider, useCartContext };
